export default __webpack_public_path__ + "static/media/spinbtn.5ee92048.png";